Ext.define('SA.view.sidebar.business.BusinessesSidebar', {
    alias: 'widget.businesses-sidebar',
    extend: 'SA.view.SimpleContainer',

    items: [
        {
            xtype: 'sa-search-field',
            cls: 'sa-sidebar-search-field',
            emptyText: 'Business Search',
            itemId: 'sidebar-businesses-search-field',
            recentButtonTitle: 'Recent Business Searches',

            listeners: {
                enterkeypress() {
                    this.up('businesses-sidebar').onSearchFieldEnterKeyPress();
                }
            },

            recentList: {
                xtype: 'recent-businesses-list',

                recent: {
                    source: SA.data.BusinessSearches,
                    title: 'Business Searches'
                }
            }
        }, {
            xtype: 'business-search-list'
        }
    ],

    initComponent() {
        this.callParent();

        this.businessSearchList = this.down('business-search-list');
        this.searchField = this.down('#sidebar-businesses-search-field');

        this.searchField.on('select', this.onSelect, this);
    },

    afterHide() {
        this.callParent(arguments);

        this.clearSearchField();
    },

    clearSearchField() {
        this.searchField.setValue('');
    },

    onSearchFieldEnterKeyPress() {
        var value = this.searchField.getValue().trim();

        if (!value) {
            return;
        }

        SA.data.BusinessSearches.createForString(value).then(search => this.useBusinessSearch(search));
    },

    onSelect(cmp, search) {
        this.useBusinessSearch(+search);
    },

    setProjectView(view) {
        var oldProject = this.projectView && this.projectView.getProject(),
            newProject = view.getProject(),
            oldCountry = this.country,
            newCountry = newProject.getCountry();

        this.projectView = view;
        this.country = newCountry;

        this.updateSelectedBusinesses();

        Ext.destroy(this.viewBusinessesListener);

        this.viewBusinessesListener = view.on({
            'change:businessSearch': this.updateSelectedBusinesses,

            destroyable: true,
            scope: this
        });

        if (newCountry !== oldCountry) {
            this.businessSearchList.setCountry(newCountry);

            this.searchField.setFilter(search => search.country === newCountry);
        }

        if (newProject !== oldProject) {
            this.clearSearchField();
        }
    },

    updateSelectedBusinesses() {
        var projectView = this.projectView,
            businesses = projectView.getBusinessSearches ? projectView.getBusinessSearches() : [];

        this.searchField.setSelected(businesses);
    },

    useBusinessSearch(id) {
        var view = this.projectView,
            project = view.getProject(),
            hadBusinesses = project.hasBusinesses(),
            viewTypes = ['businessSearchTable'];



                if (typeof id !== 'number') {
            id = id.id;
        }



                project.addBusinessSearch(id);

        if (view.setBusinessSearch) {
            view.setBusinessSearch(id);
        }

        if (!hadBusinesses && project.hasBusinesses()) {
            if (!project.hasAttributes()) {
                viewTypes.unshift('map');
            }

            project.autoCreateViews(viewTypes);
        }

        view.save();

        SA.data.BusinessSearches.updateTimestamp(id);
        SA.Sidebar.fireUseItem('use:business', id);
    }
});